import { writable, derived } from 'svelte/store';
import { json, csv } from 'd3-fetch';
// packages
import { index } from 'd3-array';
import {
  CITY_TILESET_ID,
  SUPERVISORS_TILESET_ID,
  ASSEMBLY_TILESET_ID,
  STATE_SENATE_TILESET_ID,
  CONGRESSIONAL_TILESET_ID,
  LA_COUNCIL_TILESET_ID,
  LA_NEIGHBORHOOD_TILESET_ID,
  GARDENS_TILESET_ID,
} from './constants.js';

export const currentPage = writable(0);
export const geocoderResult = writable();
export const household = writable(true);
export const more = writable(false);
// these are the issue selections ppl make
export const issues = writable([]);
export const zones = writable([]);
// this is from the issue CSV
export const issueData = writable([]);
export const zonesData = writable([]);
export const data = writable({});
export const laCounty = writable({});
export const tileData = writable({});
export const issueChoices = writable([]);
export const zonesChoices = writable([]);
export const staticMapURLsDict = writable({});
export const slidesTracker = writable({});
export const gardenData = writable({});
export const slidesGo = writable(true);

export async function fetchIssue() {
  let call = await csv(issueURL);
  issueData.set(call);
}

export async function fetchZones() {
  let call = await csv(zonesURL);
  zonesData.set(call);
}

export async function fetchData(g) {
  let address = addressCleaner(g.place_name);
  let repUrl = `${repApi}address=${address}&key=${apiKey.key}`;

  let feed = await json(repUrl);

  data.set(feed);
  //console.log('google api feed fetched :', feed);
}

export async function fetchFeature(g) {
  let repsData = await csv(repURL);

  let coord = g.center;
  let tileApi = `https://api.mapbox.com/v4/${CITY_TILESET_ID},${SUPERVISORS_TILESET_ID},${ASSEMBLY_TILESET_ID},${STATE_SENATE_TILESET_ID},${CONGRESSIONAL_TILESET_ID},${LA_COUNCIL_TILESET_ID},${LA_NEIGHBORHOOD_TILESET_ID}/tilequery/${coord[0]},${coord[1]}.json?&limit=7&access_token=${MapboxToken}`;

  let tileFeed = await json(tileApi);
  let features = tileFeed.features.map((d) => d.properties);
  // console.log('tileset features', features);

  let items = {};
  items['place'] = features[0].id;
  items['locality'] = {};
  items['state'] = {};

  items['locality'] = features[0];
  items['county'] = features[1];
  items['county']['reps'] = filterReps(repsData, 'county');

  items['state'] = { assembly: '', state_senate: '' };
  items['state']['name'] = [features[2]['name'], features[3]['name']];
  items['state']['assembly'] = features[2];
  items['state']['state_senate'] = features[3];
  items['state']['reps'] = filterReps(repsData, 'state');

  items['federal'] = features[4];
  items['federal']['reps'] = filterReps(repsData, 'federal');

  items['locality']['subdivisions'] = { city_council: '', neighborhood: '' };
  items['locality']['subdivisions']['city_council'] = features[5];
  items['locality']['subdivisions']['neighborhood'] = features[6];

  tileData.set(items);
  process.env.NODE_ENV === 'production'
    ? ''
    : console.log('##DEV MODE## tileset parsed', items);
}

export async function fetchGardens(g) {
  let coord = g.center;
  let tileApi = `https://api.mapbox.com/v4/${GARDENS_TILESET_ID}/tilequery/${coord[0]},${coord[1]}.json?radius=4800&limit=3&dedupe&limit=7&access_token=${MapboxToken}`;

  let tileFeed = await json(tileApi);
  let features = tileFeed.features.map((d) => d.properties);

  gardenData.set(features);
}

const filterReps = (arr, area) => {
  return arr.filter((r) => r.id == area);
};

/**
 * @param {{id: string}}
 * @returns {string}
 */
export const indexByAssetName = (d) => d.assetname;

export const divisionsArray = derived(data, ($data) => {
  if (Object.keys($data).length > 0) {
    //console.log('getting divisions');
    let d = createFullList($data.divisions);
    //console.log("here's full division list from store", d);
    let dArray = Object.entries(d).reduce((acc, [key, v]) => {
      if (v.officeIndices) {
        acc[key] = v;
      }
      return acc;
    }, {});

    return dArray;
  }
});

// helper functions
const addressCleaner = (string) => {
  let cleaned = string.split().join('%20');
  return cleaned;
};

// constants
const issueURL = window.DATA_URLS.issues;
const zonesURL = window.DATA_URLS.zones;
const repURL = window.DATA_URLS.reps;
const apiKey = { key: 'AIzaSyBctFzQi3u_RP4EzMXyV4aWrHYge0heSsw' };
const repApi = 'https://civicinfo.googleapis.com/civicinfo/v2/representatives?';
const MapboxToken =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

const sections = {
  place: 'city',
  council_district: 'city',
  county: 'county',
  sldu: 'state', //senate
  sldl: 'state', //assembly
  state: 'state',
  cd: 'fed',
};

/**
 * @type {Map<string, import('../types.d').Crosswalk>}
 */
export const crosswalk = index(window.CROSSWALK, indexByAssetName);
